import React, { useState } from "react";
import {
    Table,
    Row,
    Col,
    Input,
    Button,
    Divider,
    message,
    Popconfirm,
} from "antd";
import BasicLayout, {
    ModuleContent,
    ModuleTool,
} from "../../layouts/basic/BasicLayout";
import { Link } from "react-router-dom";
import DictSelect from "../../components/DictSelect";
import DateRangeSelect from "../../components/DateRangeSelect";
import useTable from "../../hooks/useTable";
import style from "./position.module.less";
import Util from "../../services/Util";
import Main from "../share/Main";
import API from "../../services/Api";
import DataSelect from "../../components/DataSelect.js";

import {CheckCircleTwoTone,CloseCircleTwoTone} from "@ant-design/icons";
import { Typography } from 'antd';

const { Text } = Typography;

const PositionList = () => {
    const [queryWord, setQueryWord] = useState("");
    const [status, setStatus] = useState();
    const [merchantId, setMerchantId] = useState(null);
    const [page, setPage] = useState(0);
    const [category, setCategory] = useState("");
    const [dateRange, setDateRange] = useState(Util.dateRange(7 * 365, "days"));
    const path = "/position/positionEdit/";

    const onStatusChange = (status) => {
        if (status) {
            setStatus(status.id === "GENERAL_STATUS_ENABLED" ? true : false);
        } else {
            setStatus();
        }
    };

    const onCategoryChange = (c) => {
        setCategory(c);
    };

    const columns = [
        {
            title: "名称",
            dataIndex: ["title"],
            render: (text, record) => (
                <Text strong>{record.title}</Text>
            ),
        },
        {
            title: "商户",
            dataIndex: ["merchant", "title"],
        },
        {
            title: "类型",
            dataIndex: ["deviceCategory", "title"],
            render: (text, record) => (
                <Text code>{record.deviceCategory.title}</Text>
            ),
        },

        {
            title: "规则",
            dataIndex: ["rule", "title"],
            render: (text, record) => {
                if(record.rule && record.rule.title){
                    return <Text code>{(record.rule && record.rule.title) ? record.rule.title : ""}</Text>
                }else{
                    return <>-</>
                }
               
            }
            
        },
        {
            title: "可用",
            dataIndex: ["enabled"],
            render: (text, record) => (record.enabled ? (<CheckCircleTwoTone twoToneColor="#52c41a" />) : (<CloseCircleTwoTone twoToneColor="red"/>)),
        },
        {
            title: "禁用时间",
            dataIndex: "supportDisabledPeriod",         
            render: (text, record) => (record.supportDisabledPeriod ? (<CheckCircleTwoTone twoToneColor="#52c41a" />) : (<CloseCircleTwoTone twoToneColor="red"/>)),

        },
        {
            title: "操作",
            dataIndex: "id",
            fixed: 'right',
            width: 100,
            render: (text, record) => (
                <div>
                    <Link to={path + record.id}>编辑</Link>
                    {Main.isMerchant() ? (
                        <>
                            <Divider type="vertical" />
                            <Popconfirm
                                title="确定操作吗?"
                                onConfirm={() => changeEnabled(record.id)}
                            >
                                {record.enabled ? <a>停用</a> : <a>启用</a>}
                            </Popconfirm>
                        </>
                    ) : (
                        ""
                    )}
                    {record.rule ? (
                        <>
                            <Divider type="vertical" />
                            <Link to={"/position/ruleEdit/" + record.rule.id}>
                                查看规则
                            </Link>
                        </>
                    ) : (
                        ""
                    )}
                </div>
            ),
        },
    ];

    const { tableProps, reloadTable } = useTable({
        url: "positions/query",
        queryParams: {
            page,
            queryWord: queryWord,
            merchantId: merchantId ? merchantId.id : null,
            status: status,
            deviceCategoryId: category ? category.id : "",
            startDate: dateRange[0],
            endDate: dateRange[1],
        },
        onPageChange: (page) => {
            setPage(page);
        },
    });

    const onMerchantChange = (merchant) => {
        setMerchantId(merchant);
    };

    const dateRangeChange = ([startDate, endDate]) => {
        setDateRange([startDate, endDate]);
    };

    const changeEnabled = (id) => {
        API.post("/positions/changeEnabled", { id: id }).then((res) => {
            message.success("操作成功");
            reloadTable();
        });
    };

    return (
        <BasicLayout>
            <ModuleTool>
                <Row>
                    <Col flex="300px">
                        {Main.isMerchant() ? (
                            <Button type="primary" style={{ marginRight: 8 }}>
                                <Link to="/position/positionCreate">
                                    新增场所
                                </Link>
                            </Button>
                        ) : (
                            ""
                        )}
                    </Col>
                    <Col flex="auto" className={style.query_area}>
                        <DateRangeSelect
                            value={dateRange}
                            onChange={dateRangeChange}
                        />
                        <DataSelect
                            allowClear
                            onChange={onMerchantChange}
                            dataUrl="/merchants/listAll"
                            placeholder="商户"
                            className={style.dict}
                        />
                        <DictSelect
                            allowClear
                            className={style.dict}
                            onChange={onCategoryChange}
                            categoryKey="DEVICE_CATEGORY"
                            placeholder="型号"
                        />
                        <DictSelect
                            allowClear
                            className={style.dict}
                            onChange={onStatusChange}
                            categoryKey="GENERAL_STATUS"
                            placeholder="状态"
                        />
                        <Input.Search
                            placeholder="搜索"
                            onSearch={(g) => {
                                setQueryWord(g);
                            }}
                            className={style.query}
                        />
                    </Col>
                </Row>
            </ModuleTool>
            <ModuleContent>
                <Table {...tableProps} columns={columns} scroll={{ x: 1500, y: 800 }}/>
            </ModuleContent>
        </BasicLayout>
    );
};

export default PositionList;
